import React from "react";
import { Lock, ShieldAlert } from "lucide-react";
import ADMIN_THEME from "../theme";

export default function PlaceholderPage({ label, description, phase = "Restricted" }) {
  const isRestricted = phase === "Restricted" || description?.toLowerCase().includes("super admin");

  return (
    <div className="admin-restricted-page">
      <div className="admin-restricted-card">
        <div className={`admin-restricted-icon${isRestricted ? " is-denied" : ""}`}>
          {isRestricted ? (
            <ShieldAlert size={26} style={{ color: ADMIN_THEME.error }} />
          ) : (
            <Lock size={26} style={{ color: ADMIN_THEME.primaryLight }} />
          )}
        </div>
        <p className="admin-section-title">{phase}</p>
        <h2 className="admin-restricted-title">{label}</h2>
        {description ? <p className="admin-restricted-desc">{description}</p> : null}
        <p className="admin-restricted-foot">
          {isRestricted
            ? "Contact a super admin if you need access to this module."
            : "This module is scaffolded in the nav — implementation coming next."}
        </p>
      </div>
    </div>
  );
}
